import {useCallback, useState} from 'react';
import {useDateNowEffect, useInitialDateNow} from './useDateNow';

export const useIsEndTimeReached = (endDate: Date, tickInterval = 1000) => {
  const initialNow = useInitialDateNow();
  const endDateTime = new Date(endDate).valueOf();
  const [remaining, setRemaining] = useState(
    Math.max(0, endDateTime - initialNow),
  );
  const updateRemainingTime = useCallback(
    (now: number) => {
      const newRemaining = Math.max(0, endDateTime - now);
      if (newRemaining === 0) {
        setRemaining(newRemaining);
      }
    },
    [endDateTime],
  );
  useDateNowEffect(
    updateRemainingTime,
    remaining !== 0 && !isNaN(endDateTime) ? tickInterval : false,
  );
  return remaining === 0;
};
